import React from 'react';
import PropTypes from 'prop-types';
import CrudTab from 'react/containers/pages/CrudTab';
import IntegrationLogCrud from 'react/containers/pages/IntegrationLog/IntegrationLogCrud';

class IntegrationLog extends CrudTab {
  activeClassName = 'is-active';

  componentDidMount() {
    const {
      tab: { pathname }
    } = this.props;

    const id = this.getIntegrationId(pathname);
    try {
      new App.Routers.IntegrationLog(id);
    } catch (error) {
      console.log(`Error at instatiate App.Routers.IntegrationLog: ${error.message}`)
    }
  }

  getIntegrationId = (pathname) => {
    const params = pathname.split('/');

    return params[3];
  }

  renderCrud = () => {
    const {
      tab: {
        extra: { id }
      },
      updateTitle
    } = this.props;

    return (
      <>
        <IntegrationLogCrud
          id={id}
          isGrid={true}
          updateTitle={updateTitle}
        />
      </>
    );
  }
}

IntegrationLog.propTypes = {
  onClose: PropTypes.func,
  active: PropTypes.bool
};

export default IntegrationLog;
